import React from 'react';

import { NoPresenceIcon, WarningTriangleIcon } from '@/assets/icons/v2';

import { NO_PRESENCE_COLOR, PRESENCE_COLOR } from '../styles';
import { StatusIcon } from './styles';

interface StatusMarkProps {
	presence: boolean;
}

export function StatusMark({ presence }: Readonly<StatusMarkProps>): JSX.Element {
	if (presence) {
		return (
			<StatusIcon>
				<WarningTriangleIcon fill={PRESENCE_COLOR} />
			</StatusIcon>
		);
	}

	return (
		<StatusIcon>
			<NoPresenceIcon stroke={NO_PRESENCE_COLOR} />
		</StatusIcon>
	);
}
